var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C5.175 0 4.5 0.675 4.5 1.5V22.5C4.5 23.325 5.175 24 6 24H21C21.825 24 22.5 23.325 22.5 22.5V6L16.5 0H6Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H22.5L16.5 0V4.5C16.5 5.325 17.175 6 18 6Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5L18 6H22.5V10.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5C19.5 19.9125 19.1625 20.25 18.75 20.25H2.25C1.8375 20.25 1.5 19.9125 1.5 19.5V12C1.5 11.5875 1.8375 11.25 2.25 11.25H18.75C19.1625 11.25 19.5 11.5875 19.5 12V19.5Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76953 14.2103C4.76953 14.0123 4.92553 13.7963 5.17678 13.7963H6.56203C7.34203 13.7963 8.04403 14.3183 8.04403 15.3188C8.04403 16.2668 7.34203 16.7948 6.56203 16.7948H5.56078V17.5868C5.56078 17.8508 5.39278 18 5.17678 18C4.97878 18 4.76953 17.8508 4.76953 17.5868V14.2103ZM5.56078 14.5515V16.0455H6.56203C6.96403 16.0455 7.28203 15.6908 7.28203 15.3188C7.28203 14.8995 6.96403 14.5515 6.56203 14.5515H5.56078Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21869 18C9.02069 18 8.80469 17.892 8.80469 17.6288V14.2223C8.80469 14.007 9.02069 13.8503 9.21869 13.8503H10.5919C13.3324 13.8503 13.2724 18 10.6459 18H9.21869ZM9.59669 14.5823V17.2688H10.5919C12.2112 17.2688 12.2832 14.5823 10.5919 14.5823H9.59669Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2445 14.6303V15.5835H15.7737C15.9897 15.5835 16.2057 15.7995 16.2057 16.0088C16.2057 16.2068 15.9897 16.3688 15.7737 16.3688H14.2445V17.628C14.2445 17.838 14.0952 17.9993 13.8852 17.9993C13.6212 17.9993 13.46 17.838 13.46 17.628V14.2215C13.46 14.0063 13.622 13.8495 13.8852 13.8495H15.9905C16.2545 13.8495 16.4105 14.0063 16.4105 14.2215C16.4105 14.4135 16.2545 14.6295 15.9905 14.6295H14.2445V14.6303Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 20.25H4.5V21H18.75C19.1625 21 19.5 20.6625 19.5 20.25V19.5C19.5 19.9125 19.1625 20.25 18.75 20.25Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.8231671297247b7ae74e50be9489d992.svg";
export { ForwardRef as ReactComponent };